/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import Button from '@mui/material/Button'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'


const styles = {
  root: css`
    position: relative;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 50px 40px;
    min-height: 586px;
    max-height: 100%
  `,
  backButtonContainer: css`
    position: absolute;
    top: 10px;
    left: 10px;
    button {
      font-weight: 500;
      color: #3ea5ff;
      &:hover {
        background-color: #fff;
      }
    }
    span {
      margin-top: 2px;
      margin-right: 3px;
    }
  `,
  top: css`
    position: relative;
    height: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    h1 {
      margin: 0;
      letter-spacing: -1px;
      font-weight: 700;
    }
    p {
      text-transform: uppercase;
      color: #979797;
      text-align: center;
      font-weight: 500;
      letter-spacing: -0.5px;
    }
  `,
  center: css`
    width: 100%;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  `,
  bottom: css`
    text-align: center;
    margin-top: 20px;
    font-size: 0.9rem;
    color: #666;
  `
}

const RegistrationSkeleton = ({ 
  title, 
  subtitle, 
  children, 
  caption,
  goBack,
  isBackButtonActive,
}) => {
  return (
    <div css={styles.root}>
      {isBackButtonActive &&
        <div css={styles.backButtonContainer}>
          <Button variant='text' startIcon={<ChevronLeftIcon />} onClick={goBack}>
            Back
          </Button>
        </div>
      }

      <div css={styles.top}>
        {title && <h1>{title}</h1>}
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div css={styles.center}>{children}</div>
      {caption && <div css={styles.bottom}>{caption}</div>}
    </div>
  )
}

export default RegistrationSkeleton


